import {updateRecentSearch} from '@stencil/hotels-utils/src/recent-search-util';
import {RESET_SEGMENT_SLIDER} from '@stencil/hotels-common-reducer/src/types';
import {updateDetailsPageConfigAction} from '@stencil/hotels-details-reducer/src/actions';
import {RESET_DETAILS_DATA} from '@stencil/hotels-details-reducer/src/constants';
import {fetchDetailsStaticDataThunk} from '@stencil/hotels-details-reducer/src/thunks';
import {IUpdate_Details_Config_Action} from '@stencil/hotels-details-reducer/src/types';
import getDetailsPageUrl from '@stencil/hotels-utils/src/get-details-page-url';
import getSrpUrl from '@stencil/hotels-utils/src/get-srp-url';
import {useCallback} from 'react';
import {useStore, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {IUpdate_Filter} from '../pages/SRP/redux/types';

import {RESET_OFFER_WIDGET} from '../pages/SRP/offer-widget-redux/types';
import {fetchSrpDataThunk} from '../pages/SRP/redux/thunks';
import {
  IHotelData,
  IUpdate_Srp_Config,
  RESET_SRP_DATA,
  UPDATE_SRP_CONFIG,
} from '../pages/SRP/redux/types';
import transformVoyagerResultToFilter from '../utils/transformVoyagerResultToFilter';

export interface IOnSearchNavigateDetails {
  openInNewTab?: boolean;
  hotelData?: IHotelData;
  newFilterData?: IUpdate_Filter['actionData'];
  resetAllData?: boolean;
  exclusions?: Array<string>;
  showOverlayLoader?: boolean;
  resetOldFilter?: boolean;
  detailToSrpFlag?: boolean;
  newTabDetails?: object;
}

export function useNavigateForSearchWidget() {
  const history = useHistory();
  const store = useStore();
  const dispatch = useDispatch();

  const resetCaller = useCallback(() => {
    store.dispatch({type: RESET_SRP_DATA});
    store.dispatch({type: RESET_OFFER_WIDGET});
    store.dispatch({type: RESET_SEGMENT_SLIDER});
    store.dispatch({type: RESET_DETAILS_DATA});
  }, []);

  const updateSrpFilterCaller = useCallback((actionData: IUpdate_Srp_Config['actionData']) => {
    store.dispatch({type: UPDATE_SRP_CONFIG, actionData});
  }, []);

  const fetchSrpDataThunkCaller = useCallback((arg: boolean, showOverlayLoader: boolean) => {
    store.dispatch(fetchSrpDataThunk(arg, showOverlayLoader));
  }, []);

  const fetchDetailsDataThunkCaller = useCallback((hotelId: string) => {
    store.dispatch(fetchDetailsStaticDataThunk(hotelId));
  }, []);

  const updateDetailsPageConfigCaller = useCallback(
    (config: IUpdate_Details_Config_Action['actionData']) => {
      store.dispatch(updateDetailsPageConfigAction(config));
    },
    [],
  );

  const onSearch = (onSeachDetails: IOnSearchNavigateDetails = {}) => {
    const {
      openInNewTab = false,
      hotelData = null,
      newFilterData = {},
      resetAllData = true,
      exclusions = [],
      showOverlayLoader = false,
      resetOldFilter = false,
      detailToSrpFlag = false,
      newTabDetails = {},
    } = onSeachDetails;

    const {srp, common, details} = store.getState();
    const {
      destination,
      checkin,
      checkout,
      roomString,
      partner,
      metaPartner,
      country,
      selectedHotel,
    } = common;

    const {srpConfig, srpData} = srp;

    const offerCode = srpConfig.filter?.pc;

    if (!destination || (!destination._id && !hotelData)) return;

    let filter = transformVoyagerResultToFilter(destination) || {};

    let cityIdFromDestination = '';
    const {t, ct = {}, _id = '', n = ''} = destination;

    if ((ct && Object.keys(ct).length > 0) || _id) {
      cityIdFromDestination = ct._id || _id || '';
    }

    let hasNewFiltersToBeApplied = false;
    if (newFilterData && Object.keys(newFilterData).length) {
      hasNewFiltersToBeApplied = true;
    }

    const vcid = (srpData && srpData?.city_meta_info && srpData?.city_meta_info?.vcid) || '';

    if (
      (filter && srpData && srpData.city_meta_info && vcid !== cityIdFromDestination) ||
      resetOldFilter
    ) {
      srpConfig.filter = {};
    }

    filter = {...filter, ...srpConfig.filter};

    if (partner === 'gostays' && exclusions && !exclusions.includes('gostays')) {
      filter.tag = 'goStays';
    }
    // if (hotelData){
    //   updatePropertyDetails(hotelData.hc, hotelData.hn)
    // }

    if (!openInNewTab) {
      if (resetAllData) resetCaller();
      updateSrpFilterCaller({filter: {...filter, ...newFilterData}});
    }
    // if (t === 'hotel' || (hotelData && hotelData.hn && !hasNewFiltersToBeApplied)) {
    if (
      ((selectedHotel && selectedHotel.propertyName) ||
        (newTabDetails && newTabDetails.hn) ||
        (hotelData && hotelData.hn && !hasNewFiltersToBeApplied)) &&
      !detailToSrpFlag
    ) {
      const {staticData = {}} = details;
      const detailsPageUrl = getDetailsPageUrl({
        checkin,
        checkout,
        roomString,
        destination,
        partner,
        metaPartner,
        country,
        staticData,
        offerCode,
        appliedFilters: hotelData?.af,
        hotelData: hotelData
          ? hotelData
          : selectedHotel
          ? {
              hn: selectedHotel.propertyName,
              hc: selectedHotel.propertyId,
            }
          : {
              hn: n,
              hc: _id,
            },
      });

      if (openInNewTab) {
        window.open(detailsPageUrl, '_blank');
      } else {
        // fetchDetailsDataThunkCaller(_id);
        updateDetailsPageConfigCaller({
          vhid: _id,
          roomString,
          // ibp,
          // metaPartner,
          filter: {},
          checkin,
          checkout,
          selectedHotelStatic: {
            hn: n,
            hc: _id,
            // ibp,
            // hmd,
          },
        } as IUpdate_Details_Config_Action['actionData']);
        history.push(detailsPageUrl);
      }
    } else {
      const srpUrl = getSrpUrl({
        checkin,
        checkout,
        destination,
        roomString,
        country,
        filter: {
          ...filter,
          ...newFilterData,
        },
        partner,
      });

      if (openInNewTab) {
        window.open(srpUrl, '_blank');
      } else {
        fetchSrpDataThunkCaller(false, showOverlayLoader);
        history.push(srpUrl);
      }
    }

    updateRecentSearch({
      destination,
      checkin,
      checkout,
      roomString,
      partner,
      hotelName: hotelData?.hn,
      hotelCode: hotelData?.hc,
      country,
    });
  };

  const getSeoDetailsUrl = (item: IHotelData = null) => {
    const {common, srp} = store.getState();
    const {checkin, checkout, roomString, partner, destination, country} = common;
    const url = getDetailsPageUrl({
      hotelData: item,
      partner,
      checkin,
      checkout,
      roomString,
      offerCode: '',
      destination,
      country,
    });
    return url;
  };

  return {onSearch, getSeoDetailsUrl};
}
